var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 81,
    viewBox: "0 0 62 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M15.4329 64.7273H46.2989V61.5023H15.4329V64.7273ZM15.4329 46.2993H46.2989V43.0743H15.4329V46.2993ZM6.90988 80.1633C5.99455 80.192 5.08303 80.0331 4.2314 79.6964C3.37978 79.3597 2.60607 78.8522 1.95788 78.2053C1.31096 77.5571 0.803515 76.7834 0.466786 75.9318C0.130056 75.0802 -0.0288367 74.1686 -0.000116067 73.2533V6.91331C-0.0288367 5.99798 0.130056 5.08645 0.466786 4.23482C0.803515 3.3832 1.31096 2.60948 1.95788 1.9613C2.60607 1.31438 3.37978 0.806935 4.2314 0.470206C5.08303 0.133476 5.99455 -0.0254188 6.90988 0.00330187H43.0749L61.7329 18.6573V73.2493C61.7616 74.1646 61.6027 75.0762 61.266 75.9278C60.9293 76.7794 60.4218 77.5531 59.7749 78.2013C59.1269 78.8491 58.3532 79.3573 57.5014 79.6948C56.6496 80.0322 55.7377 80.1916 54.8219 80.1633H6.90988ZM41.4619 20.2733V3.2243H6.90988C6.4314 3.23408 5.95993 3.34128 5.52425 3.53934C5.08857 3.73741 4.69783 4.02219 4.37588 4.3763C4.02177 4.69825 3.73699 5.08899 3.53893 5.52466C3.34086 5.96034 3.23366 6.43181 3.22388 6.9103V73.2503C3.23366 73.7288 3.34086 74.2003 3.53893 74.6359C3.73699 75.0716 4.02177 75.4624 4.37588 75.7843C4.69783 76.1384 5.08857 76.4232 5.52425 76.6213C5.95993 76.8193 6.4314 76.9265 6.90988 76.9363H54.8219C55.3004 76.9265 55.7718 76.8193 56.2075 76.6213C56.6432 76.4232 57.0339 76.1384 57.3559 75.7843C57.71 75.4624 57.9948 75.0716 58.1928 74.6359C58.3909 74.2003 58.4981 73.7288 58.5079 73.2503V20.2703L41.4619 20.2733Z",
    fill: "url(#paint0_linear_14_3020)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_3020",
    x1: -0.00341797,
    y1: 40.0833,
    x2: 61.7362,
    y2: 40.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.54349627a0120f880673b0ef8a66ce03.svg";
export { ForwardRef as ReactComponent };